import React from "react";
import { TrendingUp, Users, ShieldCheck, Target, Briefcase } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const features = [{
  title: "Extra Opdrachten",
  description: "Toegang tot een breed scala aan opdrachten bij gerenommeerde HBO-instellingen die passen bij uw expertise.",
  icon: <TrendingUp className="w-6 h-6 text-chart-2" />
}, {
  title: "Regie & Vrijheid",
  description: "U behoudt de volledige controle over uw eigen agenda en kiest de opdrachten die u echt inspireren.",
  icon: <Target className="w-6 h-6 text-chart-2" />
}, {
  title: "Acquisitie Support",
  description: "Wij nemen het zoekwerk en de acquisitie uit handen, zodat u zich kunt focussen op de inhoud van het onderwijs.",
  icon: <Briefcase className="w-6 h-6 text-chart-2" />
}, {
  title: "Wet DBA Zekerheid",
  description: "Volledige ontzorging en zekerheid door getoetste overeenkomsten en screening conform de actuele wetgeving.",
  icon: <ShieldCheck className="w-6 h-6 text-chart-2" />
}, {
  title: "Professioneel Netwerk",
  description: "Word onderdeel van een community van onderwijsprofessionals en profiteer van onze korte lijnen met instellingen.",
  icon: <Users className="w-6 h-6 text-chart-2" />
}];
export default function WhatMakesABusinessSellReady() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="25538" id="voor-onderwijsprofessionals" ref={ref} className={`py-24 dark bg-background text-foreground transition-opacity duration-700 ${isVisible ? "opacity-100" : "opacity-0"}`}>
      <div className="max-w-7xl mx-auto px-6">
        {}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-20">
          <div className="space-y-6">
            <span className="inline-block px-4 py-1.5 text-xs font-bold tracking-widest text-chart-2 uppercase bg-accent rounded-full font-default">
              Voor Professionals
            </span>
            <h2 className="text-4xl md:text-5xl font-bold font-default text-primary leading-tight">
              Regie over uw opdrachten, focus op onderwijs
            </h2>
            <p className="text-lg text-muted-foreground font-sans leading-relaxed max-w-xl">
              EduMedius is de partner voor extra opdrachten in het (hoger) beroepsonderwijs. Wij verbinden uw expertise aan de actuele behoeftes van onderwijsinstellingen. Geniet van de vrijheid van het ondernemerschap met de zekerheid van een professionele backoffice en getoetste overeenkomsten.
            </p>
          </div>
          
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-8">
          {features.map((feature, i) => <div key={i} data-index={i} className="flex flex-col items-start group">
              <div className="flex items-center justify-center w-12 h-12 rounded-xl bg-accent mb-6 transition-all duration-300 group-hover:scale-110 group-hover:shadow-lg group-hover:shadow-chart-2/20">
                {feature.icon}
              </div>
              <h3 className="text-lg font-bold font-default text-primary mb-3">
                {feature.title}
              </h3>
              <p className="text-sm text-muted-foreground font-sans leading-relaxed">
                {feature.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}